import Input from 'components/atoms/input/Input'
import Label from 'components/atoms/input/input-label/InputLabel'
import RadioButton from 'components/atoms/radio-button/RadioButton'
import { customStyles } from 'lib/helpers/configs/customStyles'
import { useAllSources as useAppointmentSources } from 'lib/hooks/queries/AppointmentSource/useAllSources'
import { useAllSources as useLeadSources } from 'lib/hooks/queries/Source/useAllSources'
import React, { FC, useMemo } from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import CreatableSelect from 'react-select/creatable'


interface Props {
    control: any;
    errors: any;
    watch: any;
}
const Step1GenerateToken: FC<Props> = ({ control, errors, watch }) => {

    const { t } = useTranslation()

    const { data: leadSources, isLoading: isLoadingLeadSources } = useLeadSources();
    const { data: appSources, isLoading: isLoadingAppSources } = useAppointmentSources();

    const module = watch('module');

    const formmatedSources = useMemo(() => {
        if (!leadSources || !appSources) return [];

        if (module === 'Appointment') {
            return appSources.sources.map((source: any) => ({
                label: source.name ?? "",
                value: source.id,
            }));
        }

        return leadSources.sources.map((source: any) => ({
            label: source.name ?? "",
            value: source.id,
        }));


    }, [leadSources, appSources, module]);

    return (

        <div className='rounded-[20px] bg-[#F6FBFE] p-4 pb-[30px]'>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                    <Label>
                        Preferred Module
                    </Label>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
                        <Controller
                            name='module'
                            control={control}
                            render={({ field }) => (
                                <RadioButton
                                    label={t('Appointment')}
                                    isChecked={field.value === 'Appointment'}
                                    value={'Appointment'}
                                    onChange={() => field.onChange('Appointment')}
                                    labelClassName="h-[44px] 2xl:h-[48px] items-center flex bg-white"
                                    iconWrapperClassName="!top-[21px] 2xl:!top-[23px] !right-[6px]"
                                    className="right-[8px]"
                                />
                            )}
                        />

                        <Controller
                            name='module'
                            control={control}
                            render={({ field }) => (
                                <RadioButton
                                    label={t('Lead')}
                                    isChecked={field.value === 'Lead'}
                                    value={'Lead'}
                                    onChange={() => field.onChange('Lead')}
                                    labelClassName="h-[44px] 2xl:h-[48px] items-center flex bg-white"
                                    iconWrapperClassName="!top-[21px] 2xl:!top-[23px] !right-[6px]"
                                    className="right-[8px]"
                                />
                            )}
                        />

                    </div>
                </div>
                <div className="relative">
                    <Label text={t('Source')} />
                    <Controller
                        name="source_id"
                        control={control}
                        rules={{ required: t('This field is required') }}
                        render={({ field }) => (
                            <CreatableSelect<any, false>
                                {...field}
                                placeholder={t('Choose source')}
                                options={formmatedSources}
                                isDisabled={isLoadingLeadSources || isLoadingAppSources}
                                value={
                                    field?.value
                                        ? {
                                            value: field?.value,
                                            label:
                                                (
                                                    formmatedSources?.find?.(
                                                        (item: any) => item.value === field.value
                                                    ) as { label: string } | undefined
                                                )?.label || field.value,
                                        }
                                        : null
                                }
                                className="cursor-pointer font-inter-regular react-select-container"
                                classNamePrefix="react-select"
                                onChange={(newValue: any, actionMeta: any) => {
                                    if (
                                        actionMeta.action === "select-option" &&
                                        newValue?.value
                                    ) {
                                        field.onChange(newValue.value);
                                    }
                                }}
                                styles={customStyles}
                                isValidNewOption={() => false}
                                menuPosition={"fixed"}
                                menuPortalTarget={document.body}
                            />
                        )}
                    />
                    {errors.source_id?.message && (
                      <div className="font-inter-regular text-xs text-red-600 w-max absolute bottom-[-16px] 2xl:bottom-[-16px]  left-[2px]">
                        <>{errors.source_id?.message}</>
                      </div>
                    )}
                </div>
                <Controller
                    name='name'
                    rules={{ required: t('This field is required') }}
                    control={control}
                    render={({ field }) => (
                        <Input
                            {...field}
                            label='API Token Name'
                            placeholder={t('API Token Name')}
                            error={errors.name}
                        />
                    )}
                />

            </div>
        </div>
    )
}

export default Step1GenerateToken